import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";

import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import CommonDeleteModal from "../../../../core/common/modal/commonDeleteModal";
// import { Edit } from "feather-icons-react/build/IconComponents";
import NewProduct from "./NewProduct";
import Swal from "sweetalert2";
import axios from "axios";
import { Select, Spin, Switch } from "antd";
import { BASE_CRM_URL } from "../../../components/config/config";
import EditProduct from "./EditProduct";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const PLACEHOLDER_IMAGE = "/assets/img/img-4.jpg";

const CRMProducts = () => {
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",

      render: (text, record) => (
        <div className="d-flex align-items-center gap-2">
          <img
            src={record.external_link?.trim() || PLACEHOLDER_IMAGE}
            alt={text || "Product"}
            className="img-thumbnail"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = PLACEHOLDER_IMAGE;
            }}
            style={{
              width: "50px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "4px",
              border: "1px solid #ddd",
              flexShrink: 0,
              backgroundColor: "#f5f5f5",
            }}
          />

          <span
            className="text-truncate"
            title={text || "N/A"}
            style={{ maxWidth: "200px" }}
          >
            {text || "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "Long Description",
      dataIndex: "long_description",
      key: "long_description",

      render: (text) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: "250px" }}
          title={text || "N/A"}
        >
          {text || "N/A"}
        </span>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",

      align: "right",
      render: (price) =>
        price ? (
          <span className="fw-semibold text-success">
            <i className="fa-solid fa-indian-rupee-sign me-1"></i>
            {price.toLocaleString()}
          </span>
        ) : (
          "-"
        ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      width: 100,

      align: "center",
      render: (unit) => {
        if (!unit) return "-";

        return (
          <span
            className={`badge  ${
              unit === "Device"
                ? "bg-soft-info"
                : unit === "License"
                  ? "bg-soft-warning"
                  : "bg-soft-secondary"
            }`}
          >
            {unit}
          </span>
        );
      },
    },
    {
      title: "Tax",
      key: "tax",
      width: 120,
      align: "center",
      render: (_, record) => (
        <div>
          <div>{record.tax1Name || "N/A"}</div>
          <div>{record.tax2Name || "N/A"}</div>
        </div>
      ),
    },
    {
      title: "Group",
      dataIndex: "group_name",
      key: "group_name",
      width: 100,
      align: "center",
      render: (group) => {
        if (!group) return "N/A";

        const badgeClass =
          group === "Software"
            ? "bg-soft-info"
            : group === "Hardware"
              ? "bg-soft-danger text-dark"
              : group === "Service"
                ? "bg-success"
                : "bg-secondary";

        return <span className={`badge ${badgeClass}`}>{group}</span>;
      },
    },
    // {
    //   title: "HSN Number",
    //   dataIndex: "hsnNumber",
    //   key: "hsnNumber",
    //   width: 140,
    //   align: "center",
    //   render: (text) => text || "N/A",
    // },
    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <div className="d-flex align-items-center gap-2">
          {/* Edit */}
          <div className="action-table-data">
            <div className="edit-delete-action " title="Edit">
              <Link
                to="#"
                className="me-2 p-2 shadow-sm"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditProduct(record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>

          {/* Status Toggle */}
          <Switch
            checked={record.active === 1}
            title={record.active === 1 ? "Inactive" : "Active"}
            size="small"
            onChange={(checked) => handleStatusChange(record, checked)}
          />
        </div>
      ),
    },
  ];

  const [productsCounts, setProductCounts] = useState({
    Software_Products: 0,
    Active_Products: 0,
    Hardware_Products: 0,
    Inactive_Products: 0,
  });

  const [selectedStatus, setSelectedStatus] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);

  const fetchProductCounts = async () => {
    try {
      const response = await axios.get(
        `${BASE_CRM_URL}products/GetProductCounts`,
      );

      if (response.data?.Status && response.data?.Data?.length > 0) {
        setProductCounts(response.data.Data[0]);
      }
    } catch (error) {
      console.error("Get Products Counts Error:", error);
    }
  };

  const handleStatusChange = async (record, checked) => {
    try {
      setLoading(true);

      const response = await axios.put(
        `${BASE_CRM_URL}products/UpdateItemActive`,
        {
          id: record.id,
          active: checked ? 1 : 0,
        },
      );

      if (response.data?.Status) {
        // Immediately update UI
        setProductsData((prevProducts) =>
          prevProducts.map((product) =>
            product.id === record.id
              ? { ...product, active: checked ? 1 : 0 }
              : product,
          ),
        );

        Swal.fire({
          icon: "success",
          title: "Success",
          text: checked
            ? "Product activated successfully"
            : "Product deactivated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        fetchProductCounts();
        getProducts();
      }
    } catch (error) {
      console.error("Status update error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update product status",
      });
    } finally {
      setLoading(false);
    }
  };

  const [productsData, setProductsData] = useState([]);
  console.log(productsData, "productdata");
  const [loading, setLoading] = useState(false);

  const [addProductOpen, setAddProductOpen] = useState(false);

  const getProducts = async (groupId = null, active = null) => {
    setLoading(true);

    try {
      const params = {};

      if (groupId !== null && groupId !== "all") {
        params.group_id = groupId;
      }

      if (active !== null && active !== "all") {
        params.active = active;
      }

      const response = await axios.get(`${BASE_CRM_URL}products/GetProducts`, {
        params,
      });

      if (response.data.Status) {
        setProductsData(response.data.Data || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No products found.",
          icon: "warning",
          button: "OK",
        });

        setProductsData([]);
      }
    } catch (error) {
      console.error("Products API Error:", error);

      setProductsData([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getProducts();
    fetchProductCounts();
  }, []);

  const [editProductOpen, setEditProductOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleEditProduct = (record) => {
    setSelectedProduct(record);
    setEditProductOpen(true);
  };

  const handleCloseEditProduct = () => {
    setEditProductOpen(false);
    setSelectedProduct(null);
  };

  const exportProductsExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Products");

      const generatedOn = new Date().toLocaleString("en-IN");

      // Title
      worksheet.mergeCells("A1:I1");
      worksheet.getCell("A1").value = "Products Report";

      worksheet.getCell("A1").font = {
        bold: true,
        size: 16,
      };

      worksheet.getCell("A1").alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      // Generated information
      worksheet.mergeCells("A2:I2");
      worksheet.getCell("A2").value =
        `Generated On: ${generatedOn} | Generated By: Pereco`;

      worksheet.getCell("A2").alignment = {
        horizontal: "center",
      };

      // Columns
      worksheet.columns = [
        {
          header: "ID",
          key: "id",
          width: 10,
        },
        {
          header: "Description",
          key: "description",
          width: 30,
        },
        {
          header: "Long Description",
          key: "long_description",
          width: 40,
        },
        {
          header: "Price",
          key: "price",
          width: 15,
        },
        {
          header: "Tax 1",
          key: "tax1",
          width: 12,
        },
        {
          header: "Tax 2",
          key: "tax2",
          width: 12,
        },
        {
          header: "Unit",
          key: "unit",
          width: 15,
        },
        {
          header: "Group",
          key: "group_name",
          width: 20,
        },
        {
          header: "Status",
          key: "active",
          width: 15,
        },
      ];

      // Add data
      productsData.forEach((product) => {
        worksheet.addRow({
          id: product.id ?? "",
          description: product.description ?? "",
          long_description: product.long_description ?? "",
          price: product.price ?? "",
          tax1: product.tax1 ?? "",
          tax2: product.tax2 ?? "",
          unit: product.unit ?? "",
          group_name: product.group_name ?? "",
          active:
            product.active === 1
              ? "Active"
              : product.active === 0
                ? "Inactive"
                : "",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(3);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      // Borders
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= 3) {
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            cell.alignment = {
              vertical: "middle",
              wrapText: true,
            };
          });
        }
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "3:3";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate file
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Products.xlsx");
    } catch (error) {
      console.error("Products Excel export error:", error);

      Swal.fire("Error", "Failed to generate Products Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportProductsPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "ID",
        "Description",
        "Long Description",
        "Price",
        "Tax 1",
        "Tax 2",
        "Unit",
        "Group",
        "Status",
      ];

      const rows = productsData.map((product) => [
        product.id ?? "",
        product.description ?? "",
        product.long_description ?? "",
        product.price ?? "",
        product.tax1 ?? "",
        product.tax2 ?? "",
        product.unit ?? "",
        product.group_name ?? "",
        product.active === 1
          ? "Active"
          : product.active === 0
            ? "Inactive"
            : "",
      ]);

      // Header
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Products Report", 148, 12, {
        align: "center",
      });

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn} | Generated By: Pereco`, 148, 19, {
        align: "center",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 25,

        margin: {
          top: 25,
          bottom: 18,
          left: 8,
          right: 8,
        },

        theme: "grid",

        styles: {
          fontSize: 7,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Page X of Y
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Products.pdf");
    } catch (error) {
      console.error("Products PDF export error:", error);

      Swal.fire("Error", "Failed to generate Products PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        {exportLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Products
                    </h4>
                  </ol>
                </nav>
                <p className="text-muted">Manage and add new Products</p>
              </div>
            </div>
            <ul className="table-top-head">
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={exportProductsPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={exportProductsExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>{" "}
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-success btn-sm me-2"
                onClick={() => setAddProductOpen(true)}
              >
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
              {/* <Link
                to="#"
                className="btn btn-dark"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAddUserToPackage"
              >
                <PlusCircle data-feather="plus-circle" className=" me-1" />
                Package
              </Link> */}
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-6 col-xl d-flex">
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 1 ? "border-info" : ""
                }`}
                onClick={() => {
                  setSelectedStatus(1);
                  getProducts(1, null);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card-body d-flex justify-content-between align-items-center py-2 px-3"
                  style={{ minHeight: "55px" }}
                >
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {productsCounts.Software_Products || 0}
                    </h4>

                    <p className="fw-semibold">Software</p>
                  </div>

                  <div
                    className="rounded-circle bg-info bg-opacity-10 text-info d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-laptop-code"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-xl d-flex">
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 2 ? "border-primary" : ""
                }`}
                onClick={() => {
                  setSelectedStatus(2);
                  getProducts(2, null);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card-body d-flex justify-content-between align-items-center  py-2 px-3"
                  style={{ minHeight: "55px" }}
                >
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {productsCounts.Hardware_Products || 0}
                    </h4>
                    <p className=" fw-semibold">Hardware </p>
                  </div>

                  <div
                    className="rounded-circle bg-warning bg-opacity-10  text-primary d-flex align-items-center  justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-microchip fs-4"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-xl d-flex">
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 3 ? "border-success" : ""
                }`}
                onClick={() => {
                  setSelectedStatus(3);
                  getProducts(null, 1);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card-body d-flex justify-content-between align-items-center  py-2 px-3"
                  style={{ minHeight: "55px" }}
                >
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {productsCounts.Active_Products || 0}
                    </h4>
                    <p className=" fw-semibold">Active </p>
                  </div>

                  <div
                    className="rounded-circle bg-success bg-opacity-10  text-success d-flex align-items-center  justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-box-open fs-4"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-xl d-flex">
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 4 ? "border-danger" : ""
                }`}
                onClick={() => {
                  setSelectedStatus(4);
                  getProducts(null, 0);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card-body d-flex justify-content-between align-items-center  py-2 px-3"
                  style={{ minHeight: "55px" }}
                >
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {productsCounts.Inactive_Products || 0}
                    </h4>
                    <p className=" fw-semibold">Inactive </p>
                  </div>

                  <div
                    className="rounded-circle bg-danger bg-opacity-10  text-danger d-flex align-items-center  justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-box-open fs-4"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* /product list */}
            <div className="card table-list-card ">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="dropdown me-2">
                    <Select
                      defaultValue="all"
                      style={{ width: 150, height: 38 }}
                      size="small"
                      onChange={(value) => {
                        setSelectedStatus(value);

                        switch (value) {
                          case "software":
                            getProducts(1, null);
                            break;

                          case "hardware":
                            getProducts(2, null);
                            break;

                          case "active":
                            getProducts(null, 1);
                            break;

                          case "inactive":
                            getProducts(null, 0);
                            break;

                          case "all":
                          default:
                            getProducts(null, null);
                            break;
                        }
                      }}
                      options={[
                        {
                          value: "all",
                          label: "All",
                        },
                        {
                          value: "software",
                          label: (
                            <span className="d-flex align-items-center">
                              <span
                                className="rounded-circle bg-primary me-2"
                                style={{ width: 8, height: 8 }}
                              />
                              Software
                            </span>
                          ),
                        },
                        {
                          value: "hardware",
                          label: (
                            <span className="d-flex align-items-center">
                              <span
                                className="rounded-circle bg-warning me-2"
                                style={{ width: 8, height: 8 }}
                              />
                              Hardware
                            </span>
                          ),
                        },
                        {
                          value: "active",
                          label: (
                            <span className="d-flex align-items-center">
                              <span
                                className="rounded-circle bg-success me-2"
                                style={{ width: 8, height: 8 }}
                              />
                              Active
                            </span>
                          ),
                        },
                        {
                          value: "inactive",
                          label: (
                            <span className="d-flex align-items-center">
                              <span
                                className="rounded-circle bg-danger me-2"
                                style={{ width: 8, height: 8 }}
                              />
                              Inactive
                            </span>
                          ),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "250px", // adjust height if needed
                      }}
                    >
                      <Spin size="large" />
                    </div>
                  ) : (
                    <Table columns={columns} dataSource={productsData} />
                  )}
                </div>
              </div>
            </div>
            {/* /product list */}
          </div>
          <EditProduct
            open={editProductOpen}
            onClose={handleCloseEditProduct}
            getProducts={getProducts}
            record={selectedProduct}
          />
          <NewProduct
            getProducts={getProducts}
            onClose={() => setAddProductOpen(false)}
            open={addProductOpen}
          />
          <CommonFooter />
        </div>
        <CommonDeleteModal />
      </div>
    </div>
  );
};

export default CRMProducts;
